export type FileType = 'video' | 'page' | 'pages' | 'document' | 'tabular'

export const getFileType = (attributes?: { type?: string }): FileType => {
  return (attributes?.type as FileType) || 'page'
}

export const isVideoFile = (fileType: FileType): boolean => fileType === 'video'
export const isDocumentFile = (fileType: FileType): boolean =>
  fileType === 'document'
export const isSpreadsheetFile = (title: string, fileType: FileType): boolean =>
  title.endsWith('.xlsx') || fileType === 'tabular'
export const isViewableFile = (fileType: FileType): boolean =>
  fileType === 'page' || fileType === 'pages'

export const parseStreamUrl = (url: string) => {
  try {
    const urlObj = new URL(url)
    const pathParts = urlObj.pathname.split('/')
    const videoId = pathParts[1]

    const timeParam = urlObj.searchParams.get('t')
    const startTime = timeParam ? parseInt(timeParam, 10) : 0

    return { videoId, startTime }
  } catch {
    return { videoId: null, startTime: 0 }
  }
}
